import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, OnDestroy } from '@angular/core'
import { OrgTreeView } from '../../../common/components/orgTreeView/orgTreeViewDropdown.Component'
import { ValidatedDropDown, ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import * as moment from 'moment'
import { OrgLevelGateway } from '../../../org-management/gateways/organization-gateway'
import { FulfillmentGateway } from '../../../fulfillment/gateways/fulfillment.gateway'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { VwOrgLevelDetails } from '../../../org-management/models/view-orglevel-details'
import { MyClientsCriteria } from '../../models/my-clients-criteria'
import { UserTypeGateway } from '../../../user-management/gateways/user-type-gateway'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { SearchModel } from '../../models/enrollment-search-details'
import { Router } from '@angular/router'

import { PortalGlobals } from '../../../portalglobals'
@Component({
    selector: 'MyClients',
    templateUrl: 'my-clients.component.html'
})

export class MyClientsComponent implements OnInit, AfterViewInit, OnDestroy  {
    disabled: false
    error: boolean = false
    myClientsCriteria: MyClientsCriteria
    userTypes: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef;
    @ViewChild('child') private child: OrgTreeView
    isAdmin: boolean = false

    constructor(private _routers: Router,
        private _userTypeGateway: UserTypeGateway,
        private _userAccessGateway: UserAccessGateway,
        private _fulfillmentGateway: FulfillmentGateway,
        private _orgLevelGateway: OrgLevelGateway,
        private _reportsGateway: ReportsGateway, public _global: PortalGlobals) {
    }

    ngOnInit() {
        this.myClientsCriteria = this._reportsGateway.myClientsCriteria
        this._userAccessGateway.getCurrentUser().subscribe(currentUser => {
            this.isAdmin = currentUser.IsAdmin
            if (this.isAdmin === false) {
                if (currentUser.roleCode === 'Organization Manager' || currentUser.roleCode === 'Organization Admin' || currentUser.roleCode === 'Admin / Agent') {
                    this.isAdmin = true
                }
            }
            if (!this.isAdmin) {
                this.myClientsCriteria.AgentID = currentUser.userProfileName
            }
            this.myClientsCriteria.LoginProfileID = currentUser.userProfileId.toString()
            this.myClientsCriteria.OrgID = +currentUser.orgId
            if (this.myClientsCriteria.ApplicationStartDate === ""
                || this.myClientsCriteria.ApplicationStartDate === undefined
                || this.myClientsCriteria.ApplicationStartDate === null) {
                this.myClientsCriteria.ApplicationStartDate = '10/01/2005'
                this.myClientsCriteria.ApplicationEndDate = moment().format('MM/DD/YYYY')
            }
            this._userTypeGateway.getAllUserType()
                .subscribe(types => {
                    types.map(model => model.value = model.text)
                    this.userTypes = types
                    let type = {} as ValidatedSelectOptionModel
                    type.text = "Any"
                    type.value = ""
                    this.userTypes.unshift(type)
                    this.onGetEnrollments();
                })
        })
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        localStorage.removeItem('clientCriteria')
        localStorage.removeItem('countCriteria')
    }

    getEnrollmentCounts() {
        // this._routers.navigate(['counts'], { relativeTo: this.route })
    }

    onOrgChange(orgID: number) {
        // this._routers.navigateByUrl('/reports/my-clients')
        this.myClientsCriteria.OrgList = orgID.toString()
    }

    onInfoChange(fieldName: string, fieldValue: string) {
        // this._routers.navigateByUrl('/reports/my-clients')
        this.myClientsCriteria[fieldName] = fieldValue
    }

    onGetEnrollments() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (this.myClientsCriteria.ApplicationStartDate === null || this.myClientsCriteria.ApplicationEndDate === null) {
            this.error = true
            this.focusableEleTop.nativeElement.focus();
        } else {
            this.error = false
            if (localStorage.getItem('clientCriteria') === null) {
                // localStorage.setItem('countCriteria', JSON.stringify(this.myClientsCriteria))
                this._routers.navigateByUrl('/' + insCo + '/reports/my-clients').then(value => {
                    if (value)
                        this._routers.navigateByUrl('/' + insCo + '/reports/my-clients/counts')
                    else
                        this._routers.navigateByUrl('/' + insCo + '/reports/my-clients/counts')
                })
            }
        }
    }


    searchByMedicareID() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this._routers.navigateByUrl('/' + insCo + '/reports/medicareid-search')
    }

    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.onGetEnrollments()
        }
    }
}
